type ViteEnv = ImportMetaEnv & {
  readonly VITE_API_BASE_URL?: string;
  readonly VITE_APP_ENV?: 'development' | 'staging' | 'production';
  readonly VITE_RECAPTCHA_SITE_KEY?: string;
  // Shared key for the backend's FrontstoreKeyGuard on public catalog reads
  // (GET /products) — the invoice/order product pickers hit that endpoint.
  readonly VITE_FRONTSTORE_API_KEY?: string;
};



// Support runtime injection of environment variables in Docker / GitOps
function getRuntimeEnv(key: string): string | undefined {
  if (typeof window !== 'undefined') {
    return (window as any).__ENV__?.[key];
  }
  if (typeof process !== 'undefined' && process.env) {
    return process.env[key];
  }
  return undefined;
}

export function isDevEnv(): boolean {
  const val = getRuntimeEnv('VITE_APP_ENV') || import.meta.env.VITE_APP_ENV;
  return val === 'development';
}

export function isProductionEnv(): boolean {
  const val = getRuntimeEnv('VITE_APP_ENV') || import.meta.env.VITE_APP_ENV;
  return val === 'production';
}

export function getApiBaseUrl(defaultUrl = 'http://localhost:8085'): string {
  const url = getRuntimeEnv('VITE_API_BASE_URL') || import.meta.env.VITE_API_BASE_URL;
  return url && url.length > 0 ? url : defaultUrl;
}

export function getRecaptchaSiteKey(): string {
  return getRuntimeEnv('VITE_RECAPTCHA_SITE_KEY') || import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
}

export function getFrontstoreApiKey(): string | undefined {
  const key = getRuntimeEnv('VITE_FRONTSTORE_API_KEY') || import.meta.env.VITE_FRONTSTORE_API_KEY;
  return key && key.length > 0 ? key : undefined;
}

export function getBaseURL(defaultUrl = 'http://localhost:3334'): string {
  const url = getRuntimeEnv('BASE_URL') || import.meta.env.BASE_URL;
  return url && url.length > 0 ? url : defaultUrl;
}

export function getDomain(): string {
  return getRuntimeEnv('DOMAIN') || import.meta.env.DOMAIN || '';
}
